import React from 'react'

const SvgIconMessage2 = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.517 11.745C2.517 6.365 6.879 2 12.255 2c5.697 0 10.254 4.902 9.7 10.71-.44 4.453-3.993 8.117-8.434 8.692a9.666 9.666 0 0 1-5.434-.868l-4.83 1.423c-.74.224-1.432-.468-1.217-1.198l1.421-4.834a9.852 9.852 0 0 1-.944-4.18zM19.87 13.42c1.052-5.028-2.775-9.472-7.615-9.472-4.295 0-7.79 3.498-7.79 7.796 0 1.15.253 2.28.75 3.332.204.42.262.877.136 1.316l-.682 2.329c-.053.186-.204.818-.204.818s.628-.15.817-.204l2.25-.663a2.05 2.05 0 0 1 .545-.078c.292 0 .575.059.838.185a7.72 7.72 0 0 0 4.46.682c3.184-.448 5.833-2.894 6.495-6.041z"
      fill="currentColor"
    />
  </svg>
)

export default SvgIconMessage2
